import React, { Suspense } from 'react';

// Lazy load DevTools only in development
const ReactQueryDevtools = React.lazy(() =>
  process.env.NODE_ENV === 'development'
    ? import('@tanstack/react-query-devtools').then((d) => ({
        default: d.ReactQueryDevtools,
      }))
    : Promise.resolve({ default: () => null }),
);

/**
 * Conditional React Query DevTools wrapper
 * Only loads and renders DevTools in development environment
 */
export const ReactQueryDevtoolsSuspense: React.FC = () => {
  // Don't render anything in production
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools
        initialIsOpen={false}
        position="bottom-right"
        toggleButtonProps={{
          style: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 99999,
          },
        }}
      />
    </Suspense>
  );
};
